var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" your office's "),_vm._t("default",function(){return [_vm._v("default microsite")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }